<template>
    <div class="social-links">
        <div class="social-links__wrapper">
            <SdsLink
                v-if="urls.twitter"
                :to="urls.twitter"
                :aria-label="$t('Open Twitter')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-x"
                    class="social-links__icon-img"
                />
            </SdsLink>
            <SdsLink
                v-if="urls.facebook"
                :to="urls.facebook"
                :aria-label="$t('Open Facebook')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-facebook"
                    class="social-links__icon-img"
                />
            </SdsLink>
            <SdsLink
                v-if="urls.youtube"
                :to="urls.youtube"
                :aria-label="$t('Open YouTube')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-you-tube"
                    class="social-links__icon-img"
                />
            </SdsLink>
            <SdsLink
                v-if="urls.instagram"
                :to="urls.instagram"
                :aria-label="$t('Open Instagram')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-instagram"
                    class="social-links__icon-img"
                />
            </SdsLink>
            <SdsLink
                v-if="urls.tiktok"
                :to="urls.tiktok"
                :aria-label="$t('Open TikTok')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-tik-tok"
                    class="social-links__icon-img"
                />
            </SdsLink>
            <SdsLink
                v-if="urls.whatsapp"
                :to="urls.whatsapp"
                :aria-label="$t('Open Whatsapp')"
                class="social-links__icon"
            >
                <SdsIcon
                    iconName="misc-whatsapp"
                    class="social-links__icon-img"
                />
            </SdsLink>
        </div>
        <div
            :class="{ 'social-links__logo--all-rights': showFooterRightsReserved }"
            class="social-links__logo"
        >
            <Illustration
                :image="logoUrl"
                :class="`social-links__logo-img`"
            />
            <div
                v-if="showFooterRightsReserved"
                class="social-links__all-rights"
            >
                {{ $t('all rights reserved', { year: currentYear }) }}
            </div>
        </div>
    </div>
</template>

<script>
    import {
        defineComponent,
        computed,
    } from '@vue/composition-api';
    import { getConfig } from '@superbet-group/web.lib.config';
    import { shellLocalConfig } from '@src/config/shell/localConfig';
    import {
        SdsIcon,
        Illustration,
        useThemedLogo,
        SdsLink,
    } from '@superbet-group/web.lib.ui-components';

    export default defineComponent({
        name: 'UseDeepLink',
        setup() {
            const urls = getConfig().countrySpecific.footer.social;
            const showFooterRightsReserved = shellLocalConfig.showFooterRightsReserved;
            const currentYear = new Date().getFullYear();
            const brand = shellLocalConfig.logo;

            const logoUrl = useThemedLogo(computed(() => `brand-${brand === 'superbet' ? 'superbet' : 'napoleon'}`));

            return {
                urls,
                showFooterRightsReserved,
                currentYear,
                logoUrl,
            };
        },
        components: {
            SdsIcon,
            Illustration,
            SdsLink,
        },
    });
</script>

<style lang="scss" scoped>
    @import '~@superbet-group/web.lib.global-styles/responsive';

    $social-links-section__padding: 24px;
    $social-links-mobile__padding-bottom: 86px;

    .social-links {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: $social-links-section__padding;

        @include respond-to-below (tSm) {
            flex-direction: column;
            justify-content: center;
            padding-top: 0;
        }

        @include respond-to-below (dXs) {
            padding-bottom: $social-links-mobile__padding-bottom;
            padding-bottom: calc(#{$social-links-mobile__padding-bottom} + env(safe-area-inset-bottom));
            padding-left: calc(#{$social-links-section__padding} + env(safe-area-inset-left));
            padding-right: calc(#{$social-links-section__padding} + env(safe-area-inset-right));
        }

        &__wrapper {
            display: flex;

            @include respond-to-below (tSm) {
                margin-bottom: 12px;

                &:empty {
                    margin-top: 0;
                }
            }
        }

        &__icon {
            margin-right: 24px;
            border-radius: 4px;

            @include respond-to-below (mSm) {
                margin-right: 16px;
            }

            &:last-child {
                margin-right: 0;
            }

            &-img {
                color: var(--system-graphics-on-elevation-secondary);
            }
        }

        &__logo {
            display: flex;
            flex-direction: column;
            align-items: center;

            &-img.illustration {
                width: 158px;
                height: 28px;
            }

            &--all-rights {
                @include respond-to-below (dXs) {
                    flex-direction: row-reverse;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                }

                @include respond-to-below (tSm) {
                    flex-direction: column;
                    justify-content: center;
                }
            }
        }

        &__all-rights {
            text-align: center;
            margin-top: 12px;

            @include respond-to-below (dXs) {
                margin-top: 0;
            }

            @include respond-to-below (tSm) {
                margin-top: 4px;
            }
        }
    }
</style>
